import { observer } from 'mobx-react-lite'

import { Briefs } from 'almanac-ui/icons/28'
import { useModals } from 'almanac-ui/Modal'
import { useRootStore } from 'stores/RootStore'
import { useAlmanacEditorState } from 'stores/EditorState'

import { BaseNextStep } from './BaseNextStep'
import { ArticleFlat } from 'types'
import { TurnIntoCustomizeModal } from 'components/BlazeCommandLine/modals/TurnIntoCustomizeModal'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { AllSelection } from 'prosemirror-state'
import { BlazeIcon } from 'components/BlazeIcon/BlazeIcon'

interface Props {
  article: ArticleFlat
  layerId: string
}

export const BrainstormNextStep = observer(function BrainstormNextStep({ article, layerId }: Props) {
  const { openModal } = useModals()
  const { docStore } = useRootStore()
  const editorState = useAlmanacEditorState()

  const handleContentBrief = () => {
    if (editorState) {
      const selection = editorState.selection.empty
        ? new AllSelection(editorState.view.state.doc)
        : editorState.selection
      const selectionText = selection.content().content.textBetween(0, selection.content().content.size)
      openModal(TurnIntoCustomizeModal, {
        layerId,
        articleId: article.id,
        content: selectionText,
        selection: editorState.selection,
        channelType: GenerationType.ContentBrief,
        isInline: false,
        isTurnInto: true,
        usePrompt: false,
      })
    }
    docStore?.rightRailStore.setActiveTab(undefined)
  }

  return (
    <BaseNextStep
      actionText="Turn your best ideas into a content brief"
      icon={<BlazeIcon icon={<Briefs />} color="var(--blaze-pink)" />}
      onPress={handleContentBrief}
    />
  )
})
